module.exports = __webpack_public_path__ + "images/18cd73cbf2821dd9399fb02d69cdd610c690f88e8ad077487099241d9b167fe1.svg";